import React from "react";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "./Icons.tsx";

interface SidebarItemProps {
  id: string;
  title: string;
  isActive: boolean;
  onSelect: (id: string) => void;
  onDelete: (e: React.MouseEvent, id: string) => void;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ id, title, isActive, onSelect, onDelete }) => {
  const { t } = useTranslation();
  return (
    <div className="group relative">
      <button
        onClick={() => onSelect(id)}
        className={`w-full text-left px-4 py-3 rounded-2xl text-sm truncate transition-all duration-300 pr-10 ${
          isActive
            ? "bg-blue-600 text-white shadow-lg shadow-blue-500/20 font-medium border-l-4 border-white/40"
            : "text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800/80 border-l-4 border-transparent"
        }`}
        title={title}
      >
        {title || t("common.new_chat", "Uus vestlus")}
      </button>
      <button
        onClick={e => onDelete(e, id)}
        className={`absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg opacity-0 group-hover:opacity-100 transition-all hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-900/20 ${
          isActive ? "text-blue-200 hover:bg-blue-500" : "text-slate-400"
        }`}
        aria-label={t("common.delete_chat", "Kustuta vestlus")}
      >
        <TrashIcon />
      </button>
    </div>
  );
};
